export default __webpack_public_path__ + "static/media/slide_1.63d74e8d.png";